import {DomainObject, oneOf} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class Annotation extends DomainObject {
  id;
  annotationType;
  top;
  left;
  width;
  height;
  pageNumber;
  annotationArgs;
  assignee;
  color;
  bounds;

  _relations = {
    annotationType: oneOf([
      'employee_signature',
      'company_signature',
      'variable',
      'custom_field',
      'input'
    ])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      annotationType: observable,
      top: observable,
      left: observable,
      width: observable,
      height: observable,
      pageNumber: observable,
      annotationArgs: observable,
      assignee: observable,
      color: observable,
      bounds: observable
    });

    this.merge(other);
  }
}

export default Annotation;
